import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { apiConfig as TreasuryContractApi } from "../contractbooking.config";
import { apiConfig } from "../../treasury/treasury.config.js";
import React from "react";

export const useSearchCustomer = (session) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState(false);

  const mutate = (searchParam) => {
    setLoading(true);
    if (!searchParam) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }
    const params = {
      exactMatch: true,
      query: searchParam.trim(),
      resource: "clients,clientIdentifiers",
    };

    let body = {
      session,
      params,
    };
    return new Promise((resolve, reject) => {
      BOM.FetchReqAction(
        body,
        TreasuryContractApi.SearchCustomer,
        (err, res) => {
          setLoading(false);
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            reject(err.defaultUserMessage);
            // setSearchParam("");
          } else {
            const objList = res;
            let tempProducts = [];
            objList?.forEach((element) => {
              tempProducts.push({
                entityAccountNo: element.entityAccountNo
                  ? element.entityAccountNo
                  : "",
                entityId: element.entityId ? element.entityId : "",
                entityMobileNo: element.entityMobileNo
                  ? element.entityMobileNo
                  : "",
                entityName: element.entityName ? element.entityName : "",
                entityType: element.entityType ? element.entityType : "",
                entityBranch: element.parentName ? element.parentName : "",
              });
            });
            const product = tempProducts.find(
              (item) => item.entityAccountNo === searchParam
            );

            // console.log(tempProducts[0]);
            // return;

            if (product === undefined) {
              setLoading(false);
              console.log(" i rannn");
              BOM.AlertMsg(cnt.DANGER, "No matching client found.");
              reject(err.defaultUserMessage);
              return;
            }

            setData(product);
            resolve(product);
          }
        }
      );
    });
  };
  return { mutate, loading, data };
};

export const useGetContractTreasuryBillList = (session) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);

  const loadData = () => {
    if (!BOM.HasPermission("READ_TREASURYBILLCONTRACT")) return;
    setLoading(true);

    let body = { session };

    BOM.FetchReqAction(
      body,
      TreasuryContractApi.GetTreasuryBillContracts,
      (err, res) => {
        console.log(res);
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              contractRefId: element?.contractReferenceId || "-",
              customerId: element?.client?.id || "-",
              date: BOM.DateTime(element?.submittedOnDate, "only-date") || "-",
              maturityDate:
                BOM.DateTime(element?.valueDate, "only-date") || "-",
              dealValue: Number(element?.faceValue)?.toLocaleString() || "-",
              currency: element?.currency.code || "-",
              status: element?.status?.text || "-",
            });
          });
          setData(tempArray);
          setLoading(false);
        }
      },
      "treasury"
    );
  };
  React.useEffect(() => {
    loadData();
  }, []);
  return { data, loading };
};

export const useGetCustomerAccounts = (session, clientId) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const loadData = () => {
    if (!clientId) return;
    if (!BOM.HasPermission("READ_TREASURYBILLCONTRACT")) return;
    setLoading(true);
    console.log("running");
    let body = { session };

    BOM.FetchReqAction(
      body,
      BOM.baseUrl(`clients/${clientId}/accounts`, "treasury"),
      (err, res) => {
        console.log(res);
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        } else {
          setData(res);
          setLoading(false);
        }
      },
      "treasury"
    );
  };
  React.useEffect(() => {
    loadData();
  }, [clientId]);
  return { data, loading };
};
export const useGetCustomer = (session, clientId) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState();
  const loadData = () => {
    if (!clientId) return;
    if (!BOM.HasPermission("READ_TREASURYBILLCONTRACT")) return;
    setLoading(true);
    console.log("running");
    let body = { session };

    BOM.FetchReqAction(
      body,
      BOM.baseUrl(`clients/${clientId}`, "treasury"),
      (err, res) => {
        console.log(res);
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        } else {
          setData(res);
          setLoading(false);
        }
      },
      "treasury"
    );
  };
  React.useEffect(() => {
    loadData();
  }, [clientId]);
  return { data, loading };
};

export const useGetTreasuryBillContractTemplate = (session) => {
  const [contractTemplate, setContractTemplate] = React.useState({});
  const [loading, setLoading] = React.useState();

  const getTreasuryBillProdTemplateAction = () => {
    // START LOAD
    setLoading(true);

    let body = { session };

    BOM.FetchReqAction(
      body,
      TreasuryContractApi.GetTreasuryBillContractTemplate,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          const objList = res;
          const amlOptions = objList?.amlScreeningOptions?.map((element) => ({
            value: element.value,
            label: element.text,
          }));
          const interestTypeOptions = objList?.interestTypeOptions?.map(
            (element) => ({
              value: element.value,
              label: element.text,
            })
          );
          const products = objList?.productOptions?.map((element) => ({
            value: element.id,
            label: element.productName,
            status: element.status,
          }));

          // Do not use spread operator
          setContractTemplate((prev) => {
            const temp = { ...prev };
            temp.amlOptions = amlOptions;
            temp.interestTypeOptions = interestTypeOptions;
            temp.products = products;
            return temp;
          });
          setLoading(false);
        }
      },
      "treasury"
    );
  };

  React.useEffect(() => {
    if (BOM.HasPermission("CREATE_INTERBANKPRODUCT")) {
      getTreasuryBillProdTemplateAction();
    }
  }, []);

  return {
    contractTemplate,
    loading,
  };
};

export const useGetTreasuryBillContract = (session, id) => {
  const [contract, setContract] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [trigger, setTrigger] = React.useState(0);
  const refetch = () => setTrigger(trigger + 1);

  const getTreasuryBillItem = () => {
    if (!id) return;
    setLoading(true);
    const url = `${TreasuryContractApi.GetTreasuryBillContract}/${id}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setLoading(false);
        const objDetail = res;
        setContract(objDetail);
      }
    });
  };

  React.useEffect(() => {
    getTreasuryBillItem();
  }, [id, trigger]);
  return { contract, loading, refetch };
};
